import { styles } from './Quality.styles';
import type { DateRange, DaySegmentKey } from './Quality.types';

/** Matches the default window `useGroundingQuality` is called with on this page. */
export const WINDOW_DAYS = 7;

/** A day's checks always split into exactly these four buckets. */
export const DAY_SEGMENT_ORDER: readonly DaySegmentKey[] = ['clean', 'flagged', 'scrubbed', 'errors'];

export const SEGMENT_FILL_CLASS: Record<DaySegmentKey, string> = {
	clean: styles.segmentClean,
	flagged: styles.segmentFlagged,
	scrubbed: styles.segmentScrubbed,
	errors: styles.segmentErrors,
};

export const SEGMENT_LABEL_KEY: Record<DaySegmentKey, string> = {
	clean: 'BY_DAY_LEGEND_CLEAN',
	flagged: 'BY_DAY_LEGEND_FLAGGED',
	scrubbed: 'BY_DAY_LEGEND_SCRUBBED',
	errors: 'BY_DAY_LEGEND_ERRORS',
};

export const DATE_RANGES: readonly DateRange[] = ['today', '7d', '30d'];
export const DEFAULT_REPORT_RANGE: DateRange = '7d';

/** Days before today each range reaches back; the API buckets by UTC day. */
export const RANGE_DAYS: Record<DateRange, number> = {
	today: 0,
	'7d': 6,
	'30d': 29,
};

export const RANGE_LABEL_KEY: Record<DateRange, string> = {
	today: 'RANGE_TODAY',
	'7d': 'RANGE_7D',
	'30d': 'RANGE_30D',
};

export const DISTRIBUTION_KEYS = ['1', '2', '3', '4', '5'] as const;

/** Keeps an empty star bucket visible as a sliver instead of disappearing. */
export const DISTRIBUTION_MIN_BAR_PCT = 4;

export const EXTERNAL_SCORE_MAX = 5;

export const REPORT_TABLE_COLUMN_KEYS = [
	'COL_DAY',
	'COL_LLM_TOTAL',
	'COL_LLM_SCORE',
	'COL_EXTERNAL_TOTAL',
	'COL_EXTERNAL_SCORE',
	'COL_EXTERNAL_AVG',
	'COL_CLOSED',
	'COL_HANDOFF',
	'COL_CONSOLIDATED',
] as const;
